import DownloadReport from "../DownloadReport";
import { useEffect } from "react";
import { capitalizeFirstLetter, isArabic, isMobileApp } from "../../../utils/util";
import { MedicalReportStatus } from "../../../utils/constants";

const dateConvert = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
};

const Modal = ({ medicalReport, closeModal, downloadReport, translationMap, showDownLoadSuccess, showCardDownLoadSuccess }) => {
  useEffect(() => {
    window.parent.scrollTo(0, 0);
  }, []);

  const handleChange = () => {
    switch (medicalReport?.medicalReportStatus.toUpperCase()) {
      case MedicalReportStatus.initiated:
        return <IntiatedStatus medicalReport={medicalReport} translationMap={translationMap} />;

      case MedicalReportStatus.completed:
        return <CompletedStatus medicalReport={medicalReport} iconClass={"active_icon"}
        text={translationMap?.completed} showDownLoadSuccess={showDownLoadSuccess}
        translationMap={translationMap} />;

      case MedicalReportStatus.processed:
        return <CompletedStatus medicalReport={medicalReport} iconClass={"yellow_icon"}
        text={translationMap?.inProgress} showDownLoadSuccess={showDownLoadSuccess}
        translationMap={translationMap} />;

      case MedicalReportStatus.failed:
        return <FailedRejectedStatus medicalReport={medicalReport} translationMap={translationMap}
        heading={translationMap?.medicalReportRequestFailed}
        status={translationMap?.failed}
        comments={medicalReport?.exceptionReason} />;

      case MedicalReportStatus.rejected:
        return <FailedRejectedStatus medicalReport={medicalReport} translationMap={translationMap}
        heading={translationMap?.medicalReportRequestReject}
        status={translationMap?.rejected} comments={medicalReport?.comments} />;

      default:
        return <CancelledStatus medicalReport={medicalReport} translationMap={translationMap}
        comments={medicalReport?.comments} />;
    }
  };

  return (
    <>
            <div
        className="modal Custom_Modal_Box Medical_Modal"
        id="medicalreport02"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{ display: "block" }}>
        
                <div className="modal-dialog " role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            {!isMobileApp() &&
              <div className="Title_Inner_Box">
                                    <h6 className="MainTitleOne">{translationMap?.medicalReportDetails}</h6>
                                </div>
              }
                        </div>
                        {showCardDownLoadSuccess &&
            <div className="Alert_Main_Box">
                                    <div
                className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                                        <button type="button" className="close" data-dismiss="alert">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                                                <path
                      d="M17 7L7 17M7 7L17 17"
                      stroke="#002F70"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                    
                                            </svg>
                                        </button>
                                        <div className="Icon_box">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                            <a href="javascript:void(0);">
                                                <span className="material-symbols-outlined">
                                                    check_circle
                                                </span>
                                            </a>
                                        </div>
                                        <div className="alert_text">
                                            <h6>
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                <a href="javascript:void(0);">
                                                    {translationMap?.downloadSuccess}
                                                </a>
                                            </h6>
                                        </div>
                                    </div>
                                </div>
            }
                        {handleChange()}
                        <div className="modal-footer modal_footer_btn_box2">
                            <button
                type="button"
                className="btn bluetrans_btn_link"
                data-dismiss="modal"
                onClick={closeModal}>
                
                                {translationMap?.close}
                            </button>
                            {
              medicalReport.medicalReportStatus === MedicalReportStatus.completed &&
              medicalReport.filenetVSID && medicalReport.filenetVSID !== 'null' && medicalReport.filenetVSID !== null && medicalReport.filenetVSID !== undefined ?

              <DownloadReport downloadReport={downloadReport} translationMap={translationMap}
              card={true} classbutton={"button3"} /> :

              null
              }
                        </div>
                    </div>
                </div>
            </div>
        </>);

};

const CompletedStatus = ({ medicalReport, iconClass, showDownLoadSuccess, translationMap, text }) => {
  return (
    <>
            <div className="modal-body">
                <div className="Inner_Modal_Body">
                    {showDownLoadSuccess &&
          <div className="AlertInnerBox GreenAlertInnerBox ">
                            <div className="Icon_box">
                                <p>
                        <span className="material-symbols-outlined">
                            check_circle
                        </span>
                                </p>
                            </div>
                            <div className="alert_text">
                                <h6>
                                    
                                        {translationMap?.medicalReportDownloadSuccess}
                                    
                                </h6>
                            </div>
                        </div>
          }
                    <div className="status_main_box status_main_box_bg">
                        <div className="content_box">
                            <p className="active">
                                <span className={`circle_icon ${iconClass}`}></span>
                                {text}
                            </p>
                            <h6 className="MainTitleOne">{capitalizeFirstLetter(medicalReport.doctorName)}</h6>
                            <ul className="detail_box">
                                <li>
                                    <p>
                                        <span>{translationMap?.facility}:&nbsp; </span>
                                        <p>
                                            {medicalReport.facilityName}
                                        </p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.specialty}:&nbsp;</span>
                                        <p>{medicalReport.specialtyName}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.appointmentDate}:&nbsp;</span>
                                        <p style={{ direction: "ltr" }}>{dateConvert(medicalReport.visitDate)}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.requestDate}:&nbsp;</span>
                                        <p style={{ direction: 'ltr' }}>{dateConvert(medicalReport?.requestDate)}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.requestNo}:&nbsp;</span>
                                        <p>{medicalReport.refNumber}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.hcn}:&nbsp;</span>
                                        <p>{medicalReport.mRN}</p>
                                    </p>
                                </li>
                                {medicalReport?.medicalReportStatus?.toUpperCase() === MedicalReportStatus.completed &&
                <li>
                                        <p>
                                            <span>{translationMap?.reportDate}:&nbsp;</span>
                                            <p style={{ direction: 'ltr' }}>{dateConvert(medicalReport.reportGeneratedOn)}</p>
                                        </p>
                                    </li>
                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>);

};

const FailedRejectedStatus = ({ medicalReport, translationMap, heading, status, comments }) => {
  if (comments?.trim() === MedicalReportStatus.reasonEn) {
    if (isArabic()) {
      comments = MedicalReportStatus.reasonAr;
    }
  }
  return (
    <>
            <div className="modal-body">
                <div className="Inner_Modal_Body">
                    <div className="AlertInnerBox YellowAlertInnerBox fade show">
                        <div className="Icon_box">
                            <p>
                                <span className="material-symbols-outlined">warning</span>
                            </p>
                        </div>
                        <div className="alert_text">
                            <h6>
                                
                                    {heading}
                                
                            </h6>
                            <p className="number_txt">
                                {translationMap?.seeMoreDetails}
                            </p>
                        </div>
                    </div>
                    <div className="status_main_box status_main_box_bg">
                        <div className="content_box">
                            <p className="active">
                                <span className="circle_icon orange_icon"></span>
                                {status}
                            </p>
                            <h6 className="MainTitleOne">{capitalizeFirstLetter(medicalReport.doctorName)}</h6>
                            <ul className="detail_box">
                                <li>
                                    <p>
                                        <span>{translationMap?.facility}:&nbsp; </span>
                                        <p>
                                            {medicalReport.facilityName}
                                        </p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.specialty}:&nbsp;</span>
                                        <p>{medicalReport.specialtyName}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.appointmentDate}:&nbsp;</span>
                                        <p style={{ direction: "ltr" }}>{dateConvert(medicalReport.visitDate)}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.requestDate}:&nbsp;</span>
                                        <p style={{ direction: "ltr" }}>{dateConvert(medicalReport?.requestDate)}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.requestNo}:&nbsp;</span>
                                        <p>{medicalReport.refNumber}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.hcn}:&nbsp;</span>
                                        <p>{medicalReport.mRN}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.comments}:</span>
                                        <p>
                                            {comments}
                                        </p>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>);

};

const CancelledStatus = ({ medicalReport, translationMap, comments }) => {
  return (
    <>
            <div className="modal-body">
                <div className="Inner_Modal_Body">
                    <div className="AlertInnerBox YellowAlertInnerBox fade show">
                        <div className="Icon_box">
                            <p>
                                <span className="material-symbols-outlined">warning</span>
                            </p>
                        </div>
                        <div className="alert_text">
                            <h6>
                                
                                    {translationMap?.medicalReportCancelled}
                                
                            </h6>
                            <p className="number_txt">
                                {translationMap?.pleaseTryAgain}
                            </p>
                        </div>
                    </div>
                    <div className="status_main_box status_main_box_bg">
                        <div className="content_box">
                            <p className="active">
                                <span className="circle_icon orange_icon"></span>
                                {translationMap?.failed}
                            </p>
                            <h6 className="MainTitleOne">{capitalizeFirstLetter(medicalReport.doctorName)}</h6>
                            <ul className="detail_box">
                                <li>
                                    <p>
                                        <span>{translationMap?.facility}:&nbsp; </span>
                                        <p>
                                            {medicalReport.facilityName}
                                        </p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.specialty}:&nbsp;</span>
                                        <p>{medicalReport.specialtyName}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.appointmentDate}:&nbsp;</span>
                                        <p style={{ direction: "ltr" }}>{dateConvert(medicalReport.visitDate)}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.requestDate}:&nbsp;</span>
                                        <p style={{ direction: "ltr" }}>{dateConvert(medicalReport?.requestDate)}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.requestNo}:&nbsp;</span>
                                        <p>{medicalReport.refNumber}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.hcn}:&nbsp;</span>
                                        <p>{medicalReport.mRN}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>Comments:</span>
                                        <p>
                                            {medicalReport?.exceptionReason}
                                        </p>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>);

};
const IntiatedStatus = ({ medicalReport, translationMap }) => {
  return (
    <>
            <div className="modal-body">
                <div className="Inner_Modal_Body">
                    <div className="AlertInnerBox YellowAlertInnerBox">
                        <div className="Icon_box">
                            <p>
                    <span className="material-symbols-outlined">
                        info
                    </span>
                            </p>
                        </div>
                        <div className="alert_text">
                            <h6>
                                
                                    {translationMap?.waitingPaymentConfirmation}
                                
                            </h6>
                            <p className="number_txt">
                                
                                    {translationMap?.waitingPaymentInitiated}
                                
                            </p>
                        </div>
                    </div>
                    <div className="status_main_box status_main_box_bg">
                        <div className="content_box">
                            <p className="active">
                                <span className="circle_icon yellow_icon"></span>
                                {translationMap?.waitingPaymentConfirmation}
                            </p>
                            <h6 className="MainTitleOne">{capitalizeFirstLetter(medicalReport.doctorName)}</h6>
                            <ul className="detail_box">
                                <li>
                                    <p>
                                        <span>{translationMap?.facility}:&nbsp; </span>
                                        <p>
                                            {medicalReport.facilityName}
                                        </p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.specialty}:&nbsp;</span>
                                        <p>{medicalReport.specialtyName}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.appointmentDate}:&nbsp;</span>
                                        <p style={{ direction: 'ltr' }}>{dateConvert(medicalReport.visitDate)}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.requestDate}:&nbsp;</span>
                                        <p style={{ direction: "ltr" }}>{dateConvert(medicalReport?.requestDate)}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.requestNo}:&nbsp;</span>
                                        <p>{medicalReport.refNumber}</p>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span>{translationMap?.hcn}:&nbsp;</span>
                                        <p>{medicalReport.mRN}</p>
                                    </p>
                                </li>
                                {/*<li>*/}
                                {/*  <p>*/}
                                {/*    <span>{translationMap?.reportDate}:&nbsp;</span>*/}
                                {/*    <p>{dateConvert(medicalReport.reportGeneratedOn)}</p>*/}
                                {/*  </p>*/}
                                {/*</li>*/}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>);

};

export { CompletedStatus, FailedRejectedStatus, CancelledStatus, Modal };